import './in-brackets.scss';

const correctSVGwidth = () => {
    const $inBracketCol = [...document.querySelectorAll('.col-in-bracktes')];
    const collapses = document.querySelectorAll('.collapse');
    // open collapse for height calculation for closed collapsed
    collapses.forEach(collapse => collapse.style.display = "block")
    $inBracketCol.forEach(col => {
        const $svgs = [...col.querySelectorAll('.col-in-bracktes svg')];
        $svgs.forEach(svg => svg.style.height = 0)

        const paragraphHeight = col.querySelector('.in-brackets p').clientHeight
        $svgs.forEach(svg => svg.style.height = paragraphHeight + 'px')
    })
    collapses.forEach(collapse => collapse.style.display = "")
}

window.addEventListener('resize', correctSVGwidth)

correctSVGwidth();